import styled, { css } from 'styled-components';
import { BORDER_BOX } from 'common';
import { SPACING_16 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import { RADIUS_4 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/border-radius';

const Container = styled.div`
  ${BORDER_BOX}
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-width: 0.0625rem;
  border-radius: ${RADIUS_4};
  ${({ $theme }) =>
    css`
      border-color: ${$theme.border}};
    `};
  ${({ isDragActive, $theme, error }) => {
    if (!isDragActive) {
      return css`
        background-color: ${$theme.background};
      `;
    }
    if (error) {
      return css`
        background-color: ${$theme.onDrop.error.background};
      `;
    }
    return css`
      background-color: ${$theme.onDrop.background};
    `;
  }}
  border-style: dashed;
  padding: ${SPACING_16};
  outline: none;
`;

const IconWrapper = styled.div`
  width: fit-content;
  margin: 0 auto ${SPACING_16} auto;
`;

const FileUploadSection = styled.div`
  width: 100%;
  text-align: center;
`;

const LabelContainer = styled.div`
  ${BORDER_BOX}
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0.1875rem ${SPACING_16};
`;

const Input = styled.input``;

export default {
  Container,
  IconWrapper,
  FileUploadSection,
  LabelContainer,
  Input
};
